import { connect } from 'react-redux';
import moment from 'moment';
import Header from '../components/header/Header';
import { getCapitalizedName } from '../utils';

const getAdultsLabel = numOfAdults => (numOfAdults > 1 ? `${numOfAdults} Adults` : '1 Adult');

const getChildrenLabel = (numOfChildren) => {
  if (!numOfChildren) return '';
  return numOfChildren > 1 ? `, ${numOfChildren} Children` : ', 1 Child';
};

const getToddlersLabel = (numOfToddlers) => {
  if (!numOfToddlers) return '';
  return numOfToddlers > 1 ? `, ${numOfToddlers} Toddlers` : ', 1 Toddler';
};

const getInfantsLabel = (numOfInfants) => {
  if (!numOfInfants) return '';
  return numOfInfants > 1 ? `, ${numOfInfants} Infants` : ', 1 Infant';
};

const getGuestSummaryText = ({ numOfAdults, numOfChildren, numOfToddlers, numOfInfants }) => {
  const adultsLabel = getAdultsLabel(numOfAdults);
  const childrenLabel = getChildrenLabel(numOfChildren);
  const toddlersLabel = getToddlersLabel(numOfToddlers);
  const infantsLabel = getInfantsLabel(numOfInfants);

  return `${adultsLabel}${childrenLabel}${toddlersLabel}${infantsLabel}`;
};

const getResortName = ({ siteCode }) => {
  const resort = siteCode.toLowerCase();
  if (resort === 'sk') return 'Skegness';
  if (resort === 'mh') return 'Minehead';
  return 'Bognor Regis';
};

const mapStateToProps = ({ bookingSearch }, {
  backgroundType,
  showProfile,
  icon,
  showLogo,
  clickHamburger,
  minimalHeader,
}) => ({
  backgroundType,
  showProfile,
  icon,
  showLogo,
  clickHamburger,
  userName: getCapitalizedName(bookingSearch.fullName),
  type: getResortName(bookingSearch),
  date: moment(bookingSearch.arrivalDate).format('YYYY-MM-DD'),
  members: getGuestSummaryText(bookingSearch),
  referenceValue: `${bookingSearch.siteCode.toUpperCase()}${bookingSearch.resId}`,
  minimalHeader,
});

export default connect(mapStateToProps, null)(Header);
